import React from 'react';

export interface PublishingContextType {
  isSharedWebpage: boolean | null;
  liveView: boolean | null;
  publishing: number | false | null;
  interactiveSharedFilters?: object | null;
}

export const PublishingContext = React.createContext<PublishingContextType>({
  isSharedWebpage: null,
  liveView: null,
  publishing: null,
  interactiveSharedFilters: null,
});
